import React, { useEffect, useState, useContext, useMemo } from "react";
import { TailSpin } from "react-loader-spinner";
import Home from "../../../../Assets/Images/Home.png";
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import AuthContext from "../../../../Context/AuthContext";
import GroupReportContext from "../../../../Context/GroupReportContext";
import { formatDate } from "../../../../utils/helper";

const styles = {
  coverScrollWrapper: {
    overflowX: "hidden", // horizontal scroll
    overflowY: "auto", // vertical scroll disable
    margin: "0 auto", // center on page
    background: "#fff",
    position: "relative",
    boxSizing: "border-box", // Optional: for visual reference, remove if not needed
  },
  coverSection: {
    height: "100%",
    margin: "0",
    padding: "25px 0px",
    borderRadius: "5px",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Helvetica, sans-serif",
    background: "white",
  },
  coverTitle: {
    fontSize: "24px",
    color: "#00577D",
    fontWeight: 700,
    lineHeight: "35px",
    letterSpacing: "0px",
    textTransform: "uppercase",
    textAlign: "center",
    fontFamily: "Helvetica, sans-serif",
  },
  coverSubtitle: {
    fontSize: "18px",
    color: "#00577D",
    width: "315px",
    lineHeight: "18px",
    fontWeight: "bold",
    letterSpacing: "0px",
    textAlign: "center",
    fontFamily: "Helvetica, sans-serif",
  },
  coverSubText: {
    fontSize: "10px",
    color: "#00577D",
    width: "315px",
    lineHeight: "14px",
    fontWeight: 400,
    letterSpacing: "0px",
    textAlign: "center",
    marginTop: "32px",
    fontFamily: "Helvetica, sans-serif",
  },
  coverImage: {
    width: "229px",
    height: "231px",
    marginTop: "50px",
    objectFit: "contain",
    display: "block",
  },
  detailSection: {
    marginTop: "50px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    textAlign: "center",
    color: "#000"
  },
  detailTitle: {
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "17px",
    color: "#5795B2",
    letterSpacing: "0px",
    textAlign: "center",
    fontFamily: "Helvetica, sans-serif",
    paddingBottom: "16px"
  },
  detailSubtitle: {
    fontSize: "10px",
    letterSpacing: "0px",
    textAlign: "center",
    fontFamily: "Helvetica, sans-serif",
    textTransform: "capitalize",
  },
  teamName: {
    margin: "0",
    fontSize: "10px",
    fontWeight: "700",
    lineHeight: "14px",

  },
  detailCompanyName: {
    fontSize: "10px",
    fontWeight: "400",
    lineHeight: "14px",
  },
  author: {
    marginTop: "16px",
    fontWeight: 700,
    fontSize: "10px",
    letterSpacing: "0px",
    textAlign: "center",
    lineHeight: "14px",
    fontFamily: "Helvetica, sans-serif",
  },
};

const CoverPage = ({ name, apiData, previewData, pageNumber, reportType, teamName, reportDataName, groupData }) => {
  // console.log("CoverPage apiData", apiData);
  //  console.log("CoverPage previewData", previewData);
  // console.log("pageNumber", pageNumber);
  // console.log("CoverPage reportType", reportType);


  // Get assessment type from API data designation or fallback to default
  const assessmentType = reportType == "SELF REPORT" ? "SELF-ASSESSMENT" : reportType == "360 REPORT" ? "360-ASSESSMENT" : "GROUP-REPORT";

  const [clientName, setClientName] = useState(teamName || "");
  const [companyName, setCompanyName] = useState("");
  const [createdDate, setCreatedDate] = useState("");
  const [completionDate, setCompletionDate] = useState("");
  const [createdgroup360Date, setCreatedgroup360Date] = useState("");
  const [teamMemberCount, setTeamMemberCount] = useState(0);
  // The respondent is listed with the reviewers but is not an observer.
  const countObservers = (results) => Object.values(results || {})
    .filter((result) => !["360 Assessment", "Self-Assessment"].includes(result?.designation)).length;
  const [isLoading, setIsLoading] = useState(true);
  const authCtx = useContext(AuthContext);
  const [consultantName, setConsultantName] = useState(authCtx?.userName);
  const groupContext = useContext(GroupReportContext);
  const selectedReport = groupContext?.selectedReport

  useEffect(() => {
    let assessment_hash = apiData?.hash;
    // console.log("CoverPage assessment_hash", assessment_hash);

    let previewDataarr = [];
    if (previewData && Array.isArray(previewData)) {
      previewDataarr = previewData.filter((el) => el?.reportType === 'Self');
      previewDataarr = previewDataarr.filter((el) =>
        el?._originalData?.results?.[0]?.hash === assessment_hash
      );
    }

    // console.log("CoverPage previewDataarr", previewDataarr);
    let completionDate = groupContext?.selectedReport?.createdDate;
    // console.log("CoverPage completionDate", completionDate);
    //Format as Aug 28, 2025
    setCompletionDate(formatDate(completionDate));

    if (reportType === "GROUP REPORT") {
      if (groupData && (groupData.teamname || groupData.assessment_hash) && teamName) {
        setIsLoading(false);
      }
    } else if (apiData && (apiData.fullName || apiData.clientData)) {
      setIsLoading(false);
    }

    if(groupContext?.currentTeamData?.results?.length){
      setTeamMemberCount(countObservers(groupContext?.currentTeamData?.results))
    }

  }, [apiData, previewData, groupContext, groupData, reportType])



  useEffect(() => {
    // Get team member count from preview data if available
    if (previewData && previewData?.length > 0) {
      const resultsData = previewData[0]?.results;
      if (resultsData) {
        const memberCount = countObservers(resultsData);
        setTeamMemberCount(memberCount);
        // console.log(
        //   "CoverPage - Team member count from preview data:",
        //   memberCount
        // );
      }
    }

    // Set clientName from teamName if provided
    if (teamName) {
      setClientName(teamName);
    }

    // Always set company name and date, regardless of teamName
    if (apiData?.clientData?.organizationName) {
      setCompanyName(apiData.clientData.organizationName);
    }
    if (apiData?.lastAsmtCompletedAt) {
      setCreatedDate(formatDate(apiData.lastAsmtCompletedAt));
    }

    // Fallback to localStorage if still missing
    if (!companyName || !createdDate) {
      const clientData = localStorage.getItem("clientData");
      if (clientData) {
        const parsedData = JSON.parse(clientData);
        if (!companyName) setCompanyName(parsedData?.company || "Company Name");
        if (!createdDate)
          setCreatedDate(formatDate(parsedData?.lastAsmtCompletedAt) || "Created Date");
      }
    }
  }, [previewData, apiData, teamName]);

  useEffect(() => {
    const rawDate =
      reportType === "SELF REPORT"
        ? groupContext?.currentTeamData?.results[0]?.completionDate ?? groupContext?.currentTeamData?.results[0]?.completionDate
        : groupContext?.selectedReport?.createdDate ?? groupContext?.currentTeamData?.createdDate;

    const reportDate = rawDate
      ? new Date(rawDate).toLocaleDateString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric",
      })
      : undefined;

    setCreatedgroup360Date(reportDate);
  }, [groupContext, reportType]);

  const headerData = useMemo(() => {
    const resolvedRespondent =
      reportType === "GROUP REPORT"
        ? (selectedReport?.teamName || clientName)
        : apiData?.fullName || clientName;
    const resolvedCompletionDate = createdgroup360Date || createdDate;
    const resolvedReportName = reportDataName || resolvedRespondent;

    return {
      respondentName: resolvedRespondent,
      companyName: companyName,
      date: createdDate,
      reportDataName: resolvedReportName,
      completionDate: resolvedCompletionDate,
    };
  }, [
    apiData?.fullName,
    clientName,
    companyName,
    createdDate,
    createdgroup360Date,
    reportDataName,
    reportType,
    selectedReport?.teamName,
  ]);

  useEffect(() => {
    const hasValue = Object.values(headerData).some(Boolean);
    if (hasValue) {
      sessionStorage.setItem("selfReportHeaderData", JSON.stringify(headerData));
    }
  }, [headerData]);


  // Add function to extract respondent names
  const getFullNames = () => {
    if (previewData && previewData?.length > 0 && previewData[0]?.results) {
      return Object.values(previewData?.[0]?.results)
        .map((assessment) => assessment?.fullName)
        .filter(Boolean);
    }
    return Object.values(apiData?.data || {})
      .map((item) => item?.fullName)
      .filter(Boolean);
  };

  const fullNames = getFullNames();


  if (isLoading || (reportType === "GROUP REPORT" ? !(groupData && (groupData.teamname || groupData.assessment_hash) && teamName) : !(apiData && (apiData.fullName || apiData.clientData)))) {
    return (
      <div
        style={{
          background: "rgb(255, 255, 255)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <TailSpin
          height="60"
          width="60"
          color="#007bff"
          ariaLabel="loading"
          radius="1"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        />
      </div>
    );
  }

  return (
    <div
      style={{
        background: "rgb(255, 255, 255)"
      }}
    >
      <HeaderPreview
        pageNumber={pageNumber}
        reportType={reportType}
        respondentName={
          reportType === "GROUP REPORT"
            ? (selectedReport?.teamName || clientName)
            : apiData?.fullName || clientName
        }
        companyName={companyName}
        date={createdDate}
        showDateAndAuthor={true}
        reportDataName={selectedReport?.teamName || reportDataName}
        completionDate={(createdgroup360Date || createdDate)}
      />
      <div style={styles.coverScrollWrapper}>
        <div style={styles.coverSection}>
          <div style={styles.coverTitle}>QUADRANT FLOW</div>
          <div style={styles.coverSubtitle}>{reportType === "360 REPORT" ? "360" : reportType === "GROUP REPORT" ? "GROUP" : "INDIVIDUAL"} </div>
          <div style={styles.coverSubText}>
            A Developmental Typology to Align and Unlock the <br />
            Heart, Soul, Mind, & Strength™ of Leaders, Teams, and Organizations.
          </div>
          <img src={Home} alt="Home" style={styles.coverImage} />
          <div style={styles.detailSection}>
            <div style={styles.detailTitle}>
              CERTIFIED COACH REPORT
            </div>
            <div className="capitalize" style={styles.detailSubtitle}>
              <p style={styles.teamName}>{(apiData?.fullName || clientName)}</p>
              <div className="company-name" style={styles.detailCompanyName}>{companyName}</div>
              {formatDate(createdgroup360Date || createdDate)}
              {reportType === "360 REPORT" &&  <div className="company-name" style={styles.detailCompanyName}>Observers: {teamMemberCount}</div> }
            </div>
            <div className="capitalize" style={styles.author}>
              Facilitator:  {consultantName || ""}
            </div>
          </div>
        </div>
      </div>
      <FooterPreview pageNumber={0} reportType={reportType} />
    </div>
  );
};

export default CoverPage;
